import { render, staticRenderFns } from "./PathNotFound.vue?vue&type=template&id=9d478f3e&"
import script from "./PathNotFound.vue?vue&type=script&lang=js&"
export * from "./PathNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports